import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { RelationshipsReportPayload } from '~bank-reports/types/RelationshipsReport'

export const relationshipsReportQueryOptions = (deps: Partial<RelationshipsReportPayload>) =>
  queryOptions({
    queryKey: ['relationshipsReport', deps],
    queryFn: () => Request.post(Request.urls.bank.portalReportRelationships, { ...deps }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
